import { ServiceRequestConfig } from '~/services/createService';
import { pilot } from '~/services/serviceInstances';

type SendAlertEmailRequest = {
  id: number;
  send_to_all: boolean;
};

export const sendAlertEmail = async (
  { id, send_to_all }: SendAlertEmailRequest,
  options: ServiceRequestConfig = {},
) => {
  return await pilot.post(`/alert/${id}/trigger/`, { send_to_all }, options);
};
